export const DEFAULT_USER = {
    id: null,
    name: "",
    email: null,
    permissions: [],
    showPayments: false,
    deleted: false,
};

export const DEFAULT_STATE = {
    data: [],
    isLoading: false,
    userFormErrors: null,
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 20,
    },
};
